import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { Global, css } from '@emotion/core';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import encode from '../../../shared/utils/encodeToUrl';
import HeaderText from '../../../shared/_TBComponents/HeaderText';
import { LoginSchema } from '../../../shared/utils/loginSchemaHelper';
import PasswordNeeded from '../../login/components/shared/PasswordNeeded';
import SharedLoginForm from '../../login/components/shared/SharedLoginForm';
import useLogin from '../../login/components/hooks/useLogin';

const ModalContainer = styled('div')`
  position: fixed;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animatebottom 0.2s;
  flex-direction: column;
  @keyframes animatebottom {
    from {
      opacity: 0;
      transform: translate(-50%, 100%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
`;

const LoginContainer = styled('div')`
  background: #FFFFFF;
  border-radius: 8px;
  position: relative;
  
  #login {
    padding: 20px 80px;
  }
`;

const ModalHeader = styled('div')`
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  text-align: center;
  padding: 25px;
`;

const ModalLogin = ({
  setModal,
}) => {
  const {
    isAuthenticated,
    handleLogin,
  } = useLogin();

  const emailAddress = useSelector((state) => state.auth.data.emailAddress);
  const isDownloadButtonClicked = useSelector(
    (state) => state.sharedWorkout.ui.isDownloadButtonClicked,
  );
  const isPasswordNeeded = useSelector((state) => state.auth.data.isPasswordNeeded);

  useEffect(() => {
    if (isAuthenticated && !isDownloadButtonClicked) {
      setModal(false);
    }
  }, [isAuthenticated, isDownloadButtonClicked, setModal]);

  return (
    <ModalContainer>
      {isPasswordNeeded ? (
        <PasswordNeeded emailAddress={emailAddress} />
      ) : (
        <LoginContainer>
          <Formik
            initialValues={{
              password: '',
              username: '',
            }}
            onSubmit={(values) => {
              const submissionObject = {
                client_id: process.env.CLIENT_ID,
                client_secret: process.env.CLIENT_SECRET,
                grant_type: 'password',
                password: values.password,
                scope: 'offline_access',
                username: values.username,
              };
              handleLogin(encode(submissionObject));
            }}
            validationSchema={LoginSchema}
            render={({
              errors,
              handleSubmit,
              touched,
              values,
            }) => (
              <>
                <ModalHeader>
                  <HeaderText>Sign In</HeaderText>
                </ModalHeader>
                <Global
                  styles={css`
                .ReactModal__Content {
                  width: 420px!important;
                }
              `}
                />
                <SharedLoginForm
                  errors={errors}
                  handleNoAccountClick={() => setModal('createAccount')}
                  handleSubmit={handleSubmit}
                  googleLoginWidth='340'
                  touched={touched}
                  values={values}
                />
              </>
            )}
          />
        </LoginContainer>
      )}
    </ModalContainer>
  );
};

ModalLogin.propTypes = {
  setModal: PropTypes.func.isRequired,
};

export default ModalLogin;
